import { z } from 'zod';

export const OpenRouteServiceGetDirectionsSchema = z.object({
  features: z.array(
    z.object({
      properties: z.object({
        segments: z.array(
          z.object({
            distance: z.number(),
          }),
        ),
      }),
    }),
  ),
});
